// extracted by mini-css-extract-plugin
export default {"topLeft":"src-feature-ui-__fab_topLeft","topRight":"src-feature-ui-__fab_topRight","bottomLeft":"src-feature-ui-__fab_bottomLeft","bottomRight":"src-feature-ui-__fab_bottomRight"};